/**
 * Route for `agency-dashboard-aggregating-all-client-performanc`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { AgencyDashboardAggregatingAllClientPerformancPage } from "../features/agency-dashboard-aggregating-all-client-performanc/AgencyDashboardAggregatingAllClientPerformancPage";

export const agencyDashboardAggregatingAllClientPerformancRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/agency-dashboard-aggregating-all-client-performanc",
	component: AgencyDashboardAggregatingAllClientPerformancPage,
});

export default agencyDashboardAggregatingAllClientPerformancRoute;
